import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../hooks/hooks';
import PageLoader from '../../../../components/PageLoader';
import GlobalIssueCategoryComponent from '../components/global-issue-category.component';
import { globalIssueCategories } from '../../../../redux/global-issue-categories/action';
import { selectGlobalIssueCategoriesListItems, selectGlobalIssueCategoriesQueryItems } from '../../../../redux/global-issue-categories/selector';
import { globalDbnTaxonomyDomains } from '../../../../redux/global-dbn-taxonomy-domains/action';
import { selectGlobalDbnTaxonomyDomainsListItems } from '../../../../redux/global-dbn-taxonomy-domains/selector';

const GlobalIssueCategory = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryIssueCategoriesItems = useSelector(selectGlobalIssueCategoriesQueryItems)
  const issueCategoriesListItems = useSelector(selectGlobalIssueCategoriesListItems)
  const globalDbnTaxonomyDomainList = useSelector(selectGlobalDbnTaxonomyDomainsListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isQuery, setIsQuery] = useState<boolean>(false)

  const [selectedIssueCategories, setSelectedIssueCategories] = useState<any>({
    Platform: '',
    IsSubIssueCategory: false,
    Name: '',
    ParentIssueCategoryId: null,
    DisplayOrder: 0,
  })

  const parentIssueCategoriesList = issueCategoriesListItems?.result?.items.filter(
    (subIssueCategoryData: any) => subIssueCategoryData.IsSubIssueCategory === false
  )

  const fetchGlobalIssueCategoriesById = async () => {
    await dispatch(globalIssueCategories.query({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/service/global-issue-categories/dbn-fetch-detail`,
      entity: 'globalIssueCategories',
      jsonData: {
        Records: [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedIssueCategories({ ...selectedIssueCategories, [field]: event });
  }

  useEffect(() => {
    dispatch(globalIssueCategories.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/service/global-issue-categories/dbn-fetch`,
      entity: 'globalIssueCategories',
      jsonData: {
        Context: {},
        Records: [
          {
            IsSubIssueCategory: false
          }
        ],
        Pagination: {
          // PageNumber: pageData,
          // PageSize: pageSize,
          SortField: "GlobalIssueCategoryId",
          SortOrder: "desc",
        }
      }
    })).then(() => {
      dispatch(globalDbnTaxonomyDomains.list({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch`, 
        entity: 'GlobalDbnTaxonomyDomains', 
        jsonData:
        {
          Context: {},
          Records: [
            {
              IsSubDomain: false
            }
          ],
          Pagination: {
            // PageNumber: pageData,
            // PageSize: pageSize,
            SortField: "GlobalDBNDomainId",
            SortOrder: "desc",
          }
        }
      }))
    }).then(() => {
      if (parmas?.id > 0) {
        fetchGlobalIssueCategoriesById();
        setIsLoading(false);
      }
      else {
        setIsLoading(false);
      }
    });
  }, []);

  useEffect(() => {
    if (isQuery) {
      setSelectedIssueCategories(queryIssueCategoriesItems?.result?.items)
    }
  }, [isQuery]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      const issueCategoryData = {
        Id: selectedIssueCategories?.GlobalIssueCategoryId || 0,
        Platform: selectedIssueCategories?.Platform || '',
        Name: selectedIssueCategories?.Name || '',
        IsSubIssueCategory: selectedIssueCategories?.IsSubIssueCategory || false,
        ParentIssueCategoryId: selectedIssueCategories?.ParentIssueCategoryId || 0,
        DisplayOrder: selectedIssueCategories?.DisplayOrder || 0,
      }
      await dispatch(globalIssueCategories.resetAction({ actionType: 'update' }))
      await dispatch(globalIssueCategories.update({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/service/global-issue-categories`,
        entity: 'globalIssueCategories',
        jsonData:
        {
          Context: {},
          Records: [issueCategoryData]
        }
      })).then(() => {
        back()
      })
    } else {
      const issueCategoryData = {
        Platform: selectedIssueCategories?.Platform || '',
        Name: selectedIssueCategories?.Name || '',
        IsSubIssueCategory: selectedIssueCategories?.IsSubIssueCategory || false,
        ParentIssueCategoryId: selectedIssueCategories?.ParentIssueCategoryId || 0,
        DisplayOrder: selectedIssueCategories?.DisplayOrder || 0,
      }
      await dispatch(globalIssueCategories.resetAction({ actionType: 'create' }))
      await dispatch(globalIssueCategories.create({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/service/global-issue-categories`,
        entity: 'globalIssueCategories',
        jsonData:
        {
          Context: {},
          Records: [issueCategoryData]
        }
      })).then(() => {
        back()
      })
    }
  };

  const back = () => {
    navigate(-1)
  };

  return (
    <>
      {isLoading ? <PageLoader /> :
        <GlobalIssueCategoryComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedIssueCategories={selectedIssueCategories}
          parentIssueCategoriesList={parentIssueCategoriesList}
          globalDbnTaxonomyDomainList={globalDbnTaxonomyDomainList?.result?.items}
          back={back}
          handleFormSubmit={handleFormSubmit}
          id={parmas?.id}
        />
      }
    </>
  );
};

export default GlobalIssueCategory;
